module.exports = __webpack_public_path__ + "img/illustration-404.d767f1a4.svg";